// Copy for people and admin (docs/design/social-plan.md, phase 4): the sheet behind a person row,
// reporting, the blocked list, editing your own profile, and a group's roles and bans. One entry per
// locale; every key exists in all seven (nl is the source, the rest are translations).
export const peopleCopy = {
  nl: {
    "people.sheet.label": "Profiel van {name}",
    "people.state.friends": "Vrienden",
    "people.state.request_sent": "Verzoek verstuurd",
    "people.state.request_received": "Heeft je een verzoek gestuurd",
    "people.state.blocked": "Geblokkeerd",
    "people.mutual.friends": "Gezamenlijke vrienden",
    "people.mutual.more": "en {n} meer",
    "people.mutual.groups": "Gezamenlijke groepen",
    "people.mutual.none": "Nog geen gezamenlijke vrienden of groepen.",
    "people.sheet.unavailable": "Deze persoon is niet te zien.",
    "people.action.add": "Vriend toevoegen",
    "people.action.cancel": "Verzoek intrekken",
    "people.action.accept": "Accepteren",
    "people.action.decline": "Weigeren",
    "people.action.unfriend": "Ontvrienden",
    "people.action.block": "Blokkeren",
    "people.action.unblock": "Deblokkeren",
    "people.action.report": "Melden",
    "people.confirm.no": "Annuleren",
    "people.confirm.unfriend.title": "{name} ontvrienden?",
    "people.confirm.unfriend.body":
      "Jullie zien elkaars activiteit niet meer. Opnieuw vrienden worden kan met een nieuw verzoek.",
    "people.confirm.unfriend.yes": "Ja, ontvrienden",
    "people.confirm.block.title": "{name} blokkeren?",
    "people.confirm.block.body":
      "Jullie zien elkaar niet meer in zoeken, uitnodigingen en proeverijen. {name} krijgt hier geen bericht van en jullie vriendschap eindigt.",
    "people.confirm.block.yes": "Ja, blokkeren",
    "people.report.title": "{name} melden",
    "people.report.aspect": "Wat wil je melden?",
    "people.report.aspect.whole.user": "Deze persoon",
    "people.report.aspect.whole.group": "Deze groep",
    "people.report.aspect.name": "De naam",
    "people.report.aspect.avatar": "De afbeelding",
    "people.report.reason": "Reden",
    "people.report.reason.spam": "Spam of ongewenste uitnodigingen",
    "people.report.reason.harassment": "Lastigvallen of pesten",
    "people.report.reason.impersonation": "Doet zich voor als iemand anders",
    "people.report.reason.inappropriate": "Ongepaste inhoud",
    "people.report.reason.other": "Iets anders",
    "people.report.note": "Toelichting (optioneel)",
    "people.report.note.hint": "Maximaal 500 tekens. Alleen de beheerder van proef leest dit.",
    "people.report.submit": "Melding versturen",
    "people.report.limit": "Je hebt vandaag al veel gemeld. Probeer het morgen opnieuw.",
    "people.report.sent.title": "Bedankt voor je melding",
    "people.report.sent.body": "We kijken ernaar. De ander hoort niet dat jij hebt gemeld.",
    "people.report.sent.block": "Ook {name} blokkeren",
    "people.report.sent.done": "Klaar",
    "people.blocked.title": "Geblokkeerde mensen",
    "people.blocked.hint":
      "Geblokkeerde mensen zien je niet in zoeken, uitnodigingen en proeverijen, en weten dit niet.",
    "people.blocked.empty": "Je hebt niemand geblokkeerd.",
    "people.blocked.unblock": "Deblokkeren",
    "people.blocked.unblock.aria": "{name} deblokkeren",
    "people.edit.open": "Profiel bewerken",
    "people.edit.title": "Je profiel bewerken",
    "people.edit.name": "Naam",
    "people.edit.handle": "Gebruikersnaam",
    "people.edit.handle.hint":
      "3 tot 30 tekens: kleine letters, cijfers, punt, streepje of underscore. Je kunt hem één keer per 30 dagen wijzigen.",
    "people.edit.save": "Opslaan",
    "people.edit.saved": "Opgeslagen.",
    "people.edit.avatar.file": "Nieuwe foto",
    "people.edit.avatar.remove": "Foto verwijderen",
    "people.edit.avatar.tooBig": "Die foto is te groot. Kies een kleinere.",
    "people.edit.avatar.badType": "Kies een jpg-, png- of webp-foto.",
    "people.edit.avatar.confirm.title": "Je foto verwijderen?",
    "people.edit.avatar.confirm.body":
      "Anderen zien dan je initialen. Een nieuwe foto kies je altijd opnieuw.",
    "people.edit.avatar.confirm.yes": "Ja, verwijderen",
    "people.problem.name.empty": "Vul een naam in.",
    "people.problem.name.long": "Een naam heeft hooguit 60 tekens.",
    "people.problem.name.reserved": "Die naam kan niet.",
    "people.problem.handle.length": "Kies 3 tot 30 tekens.",
    "people.problem.handle.characters":
      "Gebruik alleen kleine letters, cijfers, punt, streepje en underscore.",
    "people.problem.handle.edges": "Begin en eindig met een letter of cijfer.",
    "people.problem.handle.reserved": "Die gebruikersnaam kan niet.",
    "people.problem.handle.taken": "Die gebruikersnaam is al in gebruik.",
    "people.problem.handle.cooldown": "Je kunt je gebruikersnaam één keer per 30 dagen wijzigen.",
    "people.group.role.makeOwner": "Maak eigenaar",
    "people.group.role.makeAdmin": "Maak beheerder",
    "people.group.role.makeMember": "Maak lid",
    "people.group.stepDown": "Eigenaar af zijn",
    "people.group.stepDown.only":
      "Je bent de enige eigenaar. Maak eerst iemand anders eigenaar, dan kun je dit neerleggen.",
    "people.group.confirm.stepDown.title": "Geen eigenaar meer zijn?",
    "people.group.confirm.stepDown.body":
      "Je blijft beheerder van de groep. Een andere eigenaar blijft de groep beheren.",
    "people.group.confirm.stepDown.yes": "Ja, leg neer",
    "people.group.confirm.makeOwner.title": "{name} eigenaar maken?",
    "people.group.confirm.makeOwner.body":
      "Eigenaren kunnen rollen wijzigen, mensen verwijderen en de groep verwijderen.",
    "people.group.confirm.makeOwner.yes": "Ja, maak eigenaar",
    "people.group.confirm.demoteOwner.title": "{name} geen eigenaar meer maken?",
    "people.group.confirm.demoteOwner.body":
      "{name} behoudt een lagere rol in de groep en kan niet meer alles beheren.",
    "people.group.confirm.demoteOwner.yes": "Ja, verlaag",
    "people.group.confirm.remove.title": "{name} uit de groep halen?",
    "people.group.confirm.remove.body": "{name} kan opnieuw meedoen met een uitnodiging.",
    "people.group.confirm.remove.yes": "Ja, verwijder",
    "people.group.confirm.ban.title": "{name} verbannen?",
    "people.group.confirm.ban.body":
      "{name} gaat uit de groep en kan niet terugkomen via een link, code of verzoek, tot je de ban opheft.",
    "people.group.confirm.ban.yes": "Ja, verban",
    "people.group.confirm.leave.title": "De groep verlaten?",
    "people.group.confirm.leave.body":
      "Je ziet de groep en zijn proeverijen niet meer. Met een nieuwe uitnodiging kom je er weer in.",
    "people.group.confirm.leave.yes": "Ja, verlaat",
    "people.group.confirm.delete.title": "{name} verwijderen?",
    "people.group.confirm.delete.body":
      "De groep verdwijnt voor alle leden. Dit kan niet ongedaan worden gemaakt.",
    "people.group.confirm.delete.yes": "Ja, verwijder de groep",
    "people.group.ban": "Verbannen",
    "people.group.bans.title": "Verbannen",
    "people.group.bans.unban": "Ban opheffen",
    "people.group.bans.unban.aria": "Ban van {name} opheffen",
    "people.group.report": "Groep melden",
    "people.group.error.lastOwner":
      "Een groep heeft altijd een eigenaar. Maak eerst iemand anders eigenaar.",
  },
  en: {
    "people.sheet.label": "Profile of {name}",
    "people.state.friends": "Friends",
    "people.state.request_sent": "Request sent",
    "people.state.request_received": "Sent you a request",
    "people.state.blocked": "Blocked",
    "people.mutual.friends": "Mutual friends",
    "people.mutual.more": "and {n} more",
    "people.mutual.groups": "Mutual groups",
    "people.mutual.none": "No mutual friends or groups yet.",
    "people.sheet.unavailable": "This person can't be shown.",
    "people.action.add": "Add friend",
    "people.action.cancel": "Cancel request",
    "people.action.accept": "Accept",
    "people.action.decline": "Decline",
    "people.action.unfriend": "Unfriend",
    "people.action.block": "Block",
    "people.action.unblock": "Unblock",
    "people.action.report": "Report",
    "people.confirm.no": "Cancel",
    "people.confirm.unfriend.title": "Unfriend {name}?",
    "people.confirm.unfriend.body":
      "You will no longer see each other's activity. You can become friends again with a new request.",
    "people.confirm.unfriend.yes": "Yes, unfriend",
    "people.confirm.block.title": "Block {name}?",
    "people.confirm.block.body":
      "You will no longer see each other in search, invites and tastings. {name} is not told, and your friendship ends.",
    "people.confirm.block.yes": "Yes, block",
    "people.report.title": "Report {name}",
    "people.report.aspect": "What do you want to report?",
    "people.report.aspect.whole.user": "This person",
    "people.report.aspect.whole.group": "This group",
    "people.report.aspect.name": "The name",
    "people.report.aspect.avatar": "The picture",
    "people.report.reason": "Reason",
    "people.report.reason.spam": "Spam or unwanted invites",
    "people.report.reason.harassment": "Harassment or bullying",
    "people.report.reason.impersonation": "Pretends to be someone else",
    "people.report.reason.inappropriate": "Inappropriate content",
    "people.report.reason.other": "Something else",
    "people.report.note": "Details (optional)",
    "people.report.note.hint": "Up to 500 characters. Only proef's operator reads this.",
    "people.report.submit": "Send report",
    "people.report.limit": "You have reported a lot today. Try again tomorrow.",
    "people.report.sent.title": "Thanks for your report",
    "people.report.sent.body":
      "We will look into it. The other person is not told that you reported.",
    "people.report.sent.block": "Also block {name}",
    "people.report.sent.done": "Done",
    "people.blocked.title": "Blocked people",
    "people.blocked.hint":
      "Blocked people can't see you in search, invites and tastings, and are not told.",
    "people.blocked.empty": "You have not blocked anyone.",
    "people.blocked.unblock": "Unblock",
    "people.blocked.unblock.aria": "Unblock {name}",
    "people.edit.open": "Edit profile",
    "people.edit.title": "Edit your profile",
    "people.edit.name": "Name",
    "people.edit.handle": "Username",
    "people.edit.handle.hint":
      "3 to 30 characters: lowercase letters, digits, dot, hyphen or underscore. You can change it once every 30 days.",
    "people.edit.save": "Save",
    "people.edit.saved": "Saved.",
    "people.edit.avatar.file": "New picture",
    "people.edit.avatar.remove": "Remove picture",
    "people.edit.avatar.tooBig": "That picture is too large. Choose a smaller one.",
    "people.edit.avatar.badType": "Choose a jpg, png or webp picture.",
    "people.edit.avatar.confirm.title": "Remove your picture?",
    "people.edit.avatar.confirm.body":
      "Others will see your initials instead. You can always choose a new picture.",
    "people.edit.avatar.confirm.yes": "Yes, remove",
    "people.problem.name.empty": "Enter a name.",
    "people.problem.name.long": "A name has at most 60 characters.",
    "people.problem.name.reserved": "That name is not available.",
    "people.problem.handle.length": "Choose 3 to 30 characters.",
    "people.problem.handle.characters":
      "Use only lowercase letters, digits, dot, hyphen and underscore.",
    "people.problem.handle.edges": "Start and end with a letter or digit.",
    "people.problem.handle.reserved": "That username is not available.",
    "people.problem.handle.taken": "That username is already taken.",
    "people.problem.handle.cooldown": "You can change your username once every 30 days.",
    "people.group.role.makeOwner": "Make owner",
    "people.group.role.makeAdmin": "Make admin",
    "people.group.role.makeMember": "Make member",
    "people.group.stepDown": "Step down as owner",
    "people.group.stepDown.only":
      "You are the only owner. Make someone else an owner first, then you can step down.",
    "people.group.confirm.stepDown.title": "Stop being an owner?",
    "people.group.confirm.stepDown.body":
      "You stay an admin of the group. Another owner keeps running it.",
    "people.group.confirm.stepDown.yes": "Yes, step down",
    "people.group.confirm.makeOwner.title": "Make {name} an owner?",
    "people.group.confirm.makeOwner.body":
      "Owners can change roles, remove people and delete the group.",
    "people.group.confirm.makeOwner.yes": "Yes, make owner",
    "people.group.confirm.demoteOwner.title": "Make {name} no longer an owner?",
    "people.group.confirm.demoteOwner.body":
      "{name} keeps a lower role in the group and can no longer manage everything.",
    "people.group.confirm.demoteOwner.yes": "Yes, lower the role",
    "people.group.confirm.remove.title": "Remove {name} from the group?",
    "people.group.confirm.remove.body": "{name} can join again with an invite.",
    "people.group.confirm.remove.yes": "Yes, remove",
    "people.group.confirm.ban.title": "Ban {name}?",
    "people.group.confirm.ban.body":
      "{name} leaves the group and can't come back through a link, code or request until you lift the ban.",
    "people.group.confirm.ban.yes": "Yes, ban",
    "people.group.confirm.leave.title": "Leave the group?",
    "people.group.confirm.leave.body":
      "You will no longer see the group or its tastings. A new invite gets you back in.",
    "people.group.confirm.leave.yes": "Yes, leave",
    "people.group.confirm.delete.title": "Delete {name}?",
    "people.group.confirm.delete.body":
      "The group disappears for all members. This can't be undone.",
    "people.group.confirm.delete.yes": "Yes, delete the group",
    "people.group.ban": "Ban",
    "people.group.bans.title": "Banned",
    "people.group.bans.unban": "Lift ban",
    "people.group.bans.unban.aria": "Lift the ban on {name}",
    "people.group.report": "Report group",
    "people.group.error.lastOwner":
      "A group always has an owner. Make someone else an owner first.",
  },
  de: {
    "people.sheet.label": "Profil von {name}",
    "people.state.friends": "Befreundet",
    "people.state.request_sent": "Anfrage gesendet",
    "people.state.request_received": "Hat dir eine Anfrage geschickt",
    "people.state.blocked": "Blockiert",
    "people.mutual.friends": "Gemeinsame Freunde",
    "people.mutual.more": "und {n} weitere",
    "people.mutual.groups": "Gemeinsame Gruppen",
    "people.mutual.none": "Noch keine gemeinsamen Freunde oder Gruppen.",
    "people.sheet.unavailable": "Diese Person kann nicht angezeigt werden.",
    "people.action.add": "Freund hinzufügen",
    "people.action.cancel": "Anfrage zurückziehen",
    "people.action.accept": "Annehmen",
    "people.action.decline": "Ablehnen",
    "people.action.unfriend": "Freundschaft beenden",
    "people.action.block": "Blockieren",
    "people.action.unblock": "Blockierung aufheben",
    "people.action.report": "Melden",
    "people.confirm.no": "Abbrechen",
    "people.confirm.unfriend.title": "Freundschaft mit {name} beenden?",
    "people.confirm.unfriend.body":
      "Ihr seht die Aktivitäten des anderen nicht mehr. Mit einer neuen Anfrage könnt ihr wieder Freunde werden.",
    "people.confirm.unfriend.yes": "Ja, beenden",
    "people.confirm.block.title": "{name} blockieren?",
    "people.confirm.block.body":
      "Ihr seht euch nicht mehr in Suche, Einladungen und Verkostungen. {name} erfährt nichts davon, und eure Freundschaft endet.",
    "people.confirm.block.yes": "Ja, blockieren",
    "people.report.title": "{name} melden",
    "people.report.aspect": "Was möchtest du melden?",
    "people.report.aspect.whole.user": "Diese Person",
    "people.report.aspect.whole.group": "Diese Gruppe",
    "people.report.aspect.name": "Den Namen",
    "people.report.aspect.avatar": "Das Bild",
    "people.report.reason": "Grund",
    "people.report.reason.spam": "Spam oder unerwünschte Einladungen",
    "people.report.reason.harassment": "Belästigung oder Mobbing",
    "people.report.reason.impersonation": "Gibt sich als jemand anderes aus",
    "people.report.reason.inappropriate": "Unangemessener Inhalt",
    "people.report.reason.other": "Etwas anderes",
    "people.report.note": "Details (optional)",
    "people.report.note.hint": "Höchstens 500 Zeichen. Nur der Betreiber von proef liest das.",
    "people.report.submit": "Meldung senden",
    "people.report.limit": "Du hast heute schon viel gemeldet. Versuche es morgen wieder.",
    "people.report.sent.title": "Danke für deine Meldung",
    "people.report.sent.body":
      "Wir sehen uns das an. Die andere Person erfährt nicht, dass du gemeldet hast.",
    "people.report.sent.block": "{name} auch blockieren",
    "people.report.sent.done": "Fertig",
    "people.blocked.title": "Blockierte Personen",
    "people.blocked.hint":
      "Blockierte Personen sehen dich nicht in Suche, Einladungen und Verkostungen und erfahren nichts davon.",
    "people.blocked.empty": "Du hast niemanden blockiert.",
    "people.blocked.unblock": "Blockierung aufheben",
    "people.blocked.unblock.aria": "Blockierung von {name} aufheben",
    "people.edit.open": "Profil bearbeiten",
    "people.edit.title": "Dein Profil bearbeiten",
    "people.edit.name": "Name",
    "people.edit.handle": "Benutzername",
    "people.edit.handle.hint":
      "3 bis 30 Zeichen: Kleinbuchstaben, Ziffern, Punkt, Bindestrich oder Unterstrich. Du kannst ihn einmal alle 30 Tage ändern.",
    "people.edit.save": "Speichern",
    "people.edit.saved": "Gespeichert.",
    "people.edit.avatar.file": "Neues Bild",
    "people.edit.avatar.remove": "Bild entfernen",
    "people.edit.avatar.tooBig": "Das Bild ist zu groß. Wähle ein kleineres.",
    "people.edit.avatar.badType": "Wähle ein jpg-, png- oder webp-Bild.",
    "people.edit.avatar.confirm.title": "Dein Bild entfernen?",
    "people.edit.avatar.confirm.body":
      "Andere sehen dann deine Initialen. Ein neues Bild kannst du jederzeit wählen.",
    "people.edit.avatar.confirm.yes": "Ja, entfernen",
    "people.problem.name.empty": "Gib einen Namen ein.",
    "people.problem.name.long": "Ein Name hat höchstens 60 Zeichen.",
    "people.problem.name.reserved": "Dieser Name ist nicht verfügbar.",
    "people.problem.handle.length": "Wähle 3 bis 30 Zeichen.",
    "people.problem.handle.characters":
      "Nur Kleinbuchstaben, Ziffern, Punkt, Bindestrich und Unterstrich sind erlaubt.",
    "people.problem.handle.edges": "Beginne und ende mit einem Buchstaben oder einer Ziffer.",
    "people.problem.handle.reserved": "Dieser Benutzername ist nicht verfügbar.",
    "people.problem.handle.taken": "Dieser Benutzername ist schon vergeben.",
    "people.problem.handle.cooldown": "Du kannst deinen Benutzernamen einmal alle 30 Tage ändern.",
    "people.group.role.makeOwner": "Zum Eigentümer machen",
    "people.group.role.makeAdmin": "Zum Admin machen",
    "people.group.role.makeMember": "Zum Mitglied machen",
    "people.group.stepDown": "Als Eigentümer zurücktreten",
    "people.group.stepDown.only":
      "Du bist der einzige Eigentümer. Mache zuerst jemand anderen zum Eigentümer, dann kannst du zurücktreten.",
    "people.group.confirm.stepDown.title": "Nicht mehr Eigentümer sein?",
    "people.group.confirm.stepDown.body":
      "Du bleibst Admin der Gruppe. Ein anderer Eigentümer leitet sie weiter.",
    "people.group.confirm.stepDown.yes": "Ja, zurücktreten",
    "people.group.confirm.makeOwner.title": "{name} zum Eigentümer machen?",
    "people.group.confirm.makeOwner.body":
      "Eigentümer können Rollen ändern, Personen entfernen und die Gruppe löschen.",
    "people.group.confirm.makeOwner.yes": "Ja, zum Eigentümer machen",
    "people.group.confirm.demoteOwner.title": "{name} nicht mehr Eigentümer sein lassen?",
    "people.group.confirm.demoteOwner.body":
      "{name} behält eine niedrigere Rolle in der Gruppe und kann nicht mehr alles verwalten.",
    "people.group.confirm.demoteOwner.yes": "Ja, Rolle senken",
    "people.group.confirm.remove.title": "{name} aus der Gruppe entfernen?",
    "people.group.confirm.remove.body": "{name} kann mit einer Einladung wieder beitreten.",
    "people.group.confirm.remove.yes": "Ja, entfernen",
    "people.group.confirm.ban.title": "{name} sperren?",
    "people.group.confirm.ban.body":
      "{name} verlässt die Gruppe und kann nicht über Link, Code oder Anfrage zurückkehren, bis du die Sperre aufhebst.",
    "people.group.confirm.ban.yes": "Ja, sperren",
    "people.group.confirm.leave.title": "Die Gruppe verlassen?",
    "people.group.confirm.leave.body":
      "Du siehst die Gruppe und ihre Verkostungen nicht mehr. Mit einer neuen Einladung kommst du wieder hinein.",
    "people.group.confirm.leave.yes": "Ja, verlassen",
    "people.group.confirm.delete.title": "{name} löschen?",
    "people.group.confirm.delete.body":
      "Die Gruppe verschwindet für alle Mitglieder. Das lässt sich nicht rückgängig machen.",
    "people.group.confirm.delete.yes": "Ja, Gruppe löschen",
    "people.group.ban": "Sperren",
    "people.group.bans.title": "Gesperrt",
    "people.group.bans.unban": "Sperre aufheben",
    "people.group.bans.unban.aria": "Sperre von {name} aufheben",
    "people.group.report": "Gruppe melden",
    "people.group.error.lastOwner":
      "Eine Gruppe hat immer einen Eigentümer. Mache zuerst jemand anderen zum Eigentümer.",
  },
  fr: {
    "people.sheet.label": "Profil de {name}",
    "people.state.friends": "Amis",
    "people.state.request_sent": "Demande envoyée",
    "people.state.request_received": "Vous a envoyé une demande",
    "people.state.blocked": "Bloqué",
    "people.mutual.friends": "Amis en commun",
    "people.mutual.more": "et {n} de plus",
    "people.mutual.groups": "Groupes en commun",
    "people.mutual.none": "Pas encore d'amis ni de groupes en commun.",
    "people.sheet.unavailable": "Cette personne ne peut pas être affichée.",
    "people.action.add": "Ajouter en ami",
    "people.action.cancel": "Annuler la demande",
    "people.action.accept": "Accepter",
    "people.action.decline": "Refuser",
    "people.action.unfriend": "Retirer des amis",
    "people.action.block": "Bloquer",
    "people.action.unblock": "Débloquer",
    "people.action.report": "Signaler",
    "people.confirm.no": "Annuler",
    "people.confirm.unfriend.title": "Retirer {name} de vos amis ?",
    "people.confirm.unfriend.body":
      "Vous ne verrez plus l'activité de l'autre. Une nouvelle demande permet de redevenir amis.",
    "people.confirm.unfriend.yes": "Oui, retirer",
    "people.confirm.block.title": "Bloquer {name} ?",
    "people.confirm.block.body":
      "Vous ne vous verrez plus dans la recherche, les invitations et les dégustations. {name} n'en est pas informé et votre amitié prend fin.",
    "people.confirm.block.yes": "Oui, bloquer",
    "people.report.title": "Signaler {name}",
    "people.report.aspect": "Que souhaitez-vous signaler ?",
    "people.report.aspect.whole.user": "Cette personne",
    "people.report.aspect.whole.group": "Ce groupe",
    "people.report.aspect.name": "Le nom",
    "people.report.aspect.avatar": "L'image",
    "people.report.reason": "Motif",
    "people.report.reason.spam": "Spam ou invitations non sollicitées",
    "people.report.reason.harassment": "Harcèlement ou intimidation",
    "people.report.reason.impersonation": "Se fait passer pour quelqu'un d'autre",
    "people.report.reason.inappropriate": "Contenu inapproprié",
    "people.report.reason.other": "Autre chose",
    "people.report.note": "Précisions (facultatif)",
    "people.report.note.hint": "500 caractères au maximum. Seul l'opérateur de proef le lit.",
    "people.report.submit": "Envoyer le signalement",
    "people.report.limit": "Vous avez déjà beaucoup signalé aujourd'hui. Réessayez demain.",
    "people.report.sent.title": "Merci pour votre signalement",
    "people.report.sent.body":
      "Nous allons l'examiner. L'autre personne n'est pas informée de votre signalement.",
    "people.report.sent.block": "Bloquer aussi {name}",
    "people.report.sent.done": "Terminé",
    "people.blocked.title": "Personnes bloquées",
    "people.blocked.hint":
      "Les personnes bloquées ne vous voient pas dans la recherche, les invitations et les dégustations, et n'en sont pas informées.",
    "people.blocked.empty": "Vous n'avez bloqué personne.",
    "people.blocked.unblock": "Débloquer",
    "people.blocked.unblock.aria": "Débloquer {name}",
    "people.edit.open": "Modifier le profil",
    "people.edit.title": "Modifier votre profil",
    "people.edit.name": "Nom",
    "people.edit.handle": "Nom d'utilisateur",
    "people.edit.handle.hint":
      "3 à 30 caractères : lettres minuscules, chiffres, point, tiret ou tiret bas. Vous pouvez le changer une fois tous les 30 jours.",
    "people.edit.save": "Enregistrer",
    "people.edit.saved": "Enregistré.",
    "people.edit.avatar.file": "Nouvelle photo",
    "people.edit.avatar.remove": "Supprimer la photo",
    "people.edit.avatar.tooBig": "Cette photo est trop grande. Choisissez-en une plus petite.",
    "people.edit.avatar.badType": "Choisissez une photo jpg, png ou webp.",
    "people.edit.avatar.confirm.title": "Supprimer votre photo ?",
    "people.edit.avatar.confirm.body":
      "Les autres verront alors vos initiales. Vous pourrez toujours choisir une nouvelle photo.",
    "people.edit.avatar.confirm.yes": "Oui, supprimer",
    "people.problem.name.empty": "Saisissez un nom.",
    "people.problem.name.long": "Un nom compte 60 caractères au maximum.",
    "people.problem.name.reserved": "Ce nom n'est pas disponible.",
    "people.problem.handle.length": "Choisissez de 3 à 30 caractères.",
    "people.problem.handle.characters":
      "Utilisez uniquement des lettres minuscules, chiffres, points, tirets et tirets bas.",
    "people.problem.handle.edges": "Commencez et terminez par une lettre ou un chiffre.",
    "people.problem.handle.reserved": "Ce nom d'utilisateur n'est pas disponible.",
    "people.problem.handle.taken": "Ce nom d'utilisateur est déjà pris.",
    "people.problem.handle.cooldown":
      "Vous pouvez changer votre nom d'utilisateur une fois tous les 30 jours.",
    "people.group.role.makeOwner": "Nommer propriétaire",
    "people.group.role.makeAdmin": "Nommer administrateur",
    "people.group.role.makeMember": "Rendre membre",
    "people.group.stepDown": "Quitter le rôle de propriétaire",
    "people.group.stepDown.only":
      "Vous êtes le seul propriétaire. Nommez d'abord quelqu'un d'autre propriétaire, puis vous pourrez quitter ce rôle.",
    "people.group.confirm.stepDown.title": "Ne plus être propriétaire ?",
    "people.group.confirm.stepDown.body":
      "Vous restez administrateur du groupe. Un autre propriétaire continue de le gérer.",
    "people.group.confirm.stepDown.yes": "Oui, quitter ce rôle",
    "people.group.confirm.makeOwner.title": "Nommer {name} propriétaire ?",
    "people.group.confirm.makeOwner.body":
      "Les propriétaires peuvent changer les rôles, retirer des personnes et supprimer le groupe.",
    "people.group.confirm.makeOwner.yes": "Oui, nommer propriétaire",
    "people.group.confirm.demoteOwner.title": "Retirer le rôle de propriétaire à {name} ?",
    "people.group.confirm.demoteOwner.body":
      "{name} garde un rôle inférieur dans le groupe et ne peut plus tout gérer.",
    "people.group.confirm.demoteOwner.yes": "Oui, baisser le rôle",
    "people.group.confirm.remove.title": "Retirer {name} du groupe ?",
    "people.group.confirm.remove.body": "{name} peut rejoindre à nouveau avec une invitation.",
    "people.group.confirm.remove.yes": "Oui, retirer",
    "people.group.confirm.ban.title": "Bannir {name} ?",
    "people.group.confirm.ban.body":
      "{name} quitte le groupe et ne peut pas revenir par lien, code ou demande, tant que vous ne levez pas le bannissement.",
    "people.group.confirm.ban.yes": "Oui, bannir",
    "people.group.confirm.leave.title": "Quitter le groupe ?",
    "people.group.confirm.leave.body":
      "Vous ne verrez plus le groupe ni ses dégustations. Une nouvelle invitation vous y ramène.",
    "people.group.confirm.leave.yes": "Oui, quitter",
    "people.group.confirm.delete.title": "Supprimer {name} ?",
    "people.group.confirm.delete.body":
      "Le groupe disparaît pour tous les membres. Cette action est irréversible.",
    "people.group.confirm.delete.yes": "Oui, supprimer le groupe",
    "people.group.ban": "Bannir",
    "people.group.bans.title": "Bannis",
    "people.group.bans.unban": "Lever le bannissement",
    "people.group.bans.unban.aria": "Lever le bannissement de {name}",
    "people.group.report": "Signaler le groupe",
    "people.group.error.lastOwner":
      "Un groupe a toujours un propriétaire. Nommez d'abord quelqu'un d'autre propriétaire.",
  },
  es: {
    "people.sheet.label": "Perfil de {name}",
    "people.state.friends": "Amigos",
    "people.state.request_sent": "Solicitud enviada",
    "people.state.request_received": "Te envió una solicitud",
    "people.state.blocked": "Bloqueado",
    "people.mutual.friends": "Amigos en común",
    "people.mutual.more": "y {n} más",
    "people.mutual.groups": "Grupos en común",
    "people.mutual.none": "Aún no hay amigos ni grupos en común.",
    "people.sheet.unavailable": "No se puede mostrar a esta persona.",
    "people.action.add": "Añadir amigo",
    "people.action.cancel": "Cancelar solicitud",
    "people.action.accept": "Aceptar",
    "people.action.decline": "Rechazar",
    "people.action.unfriend": "Quitar de amigos",
    "people.action.block": "Bloquear",
    "people.action.unblock": "Desbloquear",
    "people.action.report": "Denunciar",
    "people.confirm.no": "Cancelar",
    "people.confirm.unfriend.title": "¿Quitar a {name} de tus amigos?",
    "people.confirm.unfriend.body":
      "Dejaréis de ver la actividad del otro. Con una nueva solicitud podéis volver a ser amigos.",
    "people.confirm.unfriend.yes": "Sí, quitar",
    "people.confirm.block.title": "¿Bloquear a {name}?",
    "people.confirm.block.body":
      "Dejaréis de veros en la búsqueda, las invitaciones y las catas. {name} no recibe ningún aviso y vuestra amistad termina.",
    "people.confirm.block.yes": "Sí, bloquear",
    "people.report.title": "Denunciar a {name}",
    "people.report.aspect": "¿Qué quieres denunciar?",
    "people.report.aspect.whole.user": "A esta persona",
    "people.report.aspect.whole.group": "Este grupo",
    "people.report.aspect.name": "El nombre",
    "people.report.aspect.avatar": "La imagen",
    "people.report.reason": "Motivo",
    "people.report.reason.spam": "Spam o invitaciones no deseadas",
    "people.report.reason.harassment": "Acoso o intimidación",
    "people.report.reason.impersonation": "Se hace pasar por otra persona",
    "people.report.reason.inappropriate": "Contenido inapropiado",
    "people.report.reason.other": "Otra cosa",
    "people.report.note": "Detalles (opcional)",
    "people.report.note.hint": "Hasta 500 caracteres. Solo el operador de proef lo lee.",
    "people.report.submit": "Enviar denuncia",
    "people.report.limit": "Hoy ya has denunciado mucho. Inténtalo de nuevo mañana.",
    "people.report.sent.title": "Gracias por tu denuncia",
    "people.report.sent.body": "Lo revisaremos. La otra persona no sabe que has denunciado.",
    "people.report.sent.block": "Bloquear también a {name}",
    "people.report.sent.done": "Hecho",
    "people.blocked.title": "Personas bloqueadas",
    "people.blocked.hint":
      "Las personas bloqueadas no te ven en la búsqueda, las invitaciones y las catas, y no reciben ningún aviso.",
    "people.blocked.empty": "No has bloqueado a nadie.",
    "people.blocked.unblock": "Desbloquear",
    "people.blocked.unblock.aria": "Desbloquear a {name}",
    "people.edit.open": "Editar perfil",
    "people.edit.title": "Editar tu perfil",
    "people.edit.name": "Nombre",
    "people.edit.handle": "Nombre de usuario",
    "people.edit.handle.hint":
      "De 3 a 30 caracteres: letras minúsculas, cifras, punto, guion o guion bajo. Puedes cambiarlo una vez cada 30 días.",
    "people.edit.save": "Guardar",
    "people.edit.saved": "Guardado.",
    "people.edit.avatar.file": "Foto nueva",
    "people.edit.avatar.remove": "Quitar foto",
    "people.edit.avatar.tooBig": "Esa foto es demasiado grande. Elige una más pequeña.",
    "people.edit.avatar.badType": "Elige una foto jpg, png o webp.",
    "people.edit.avatar.confirm.title": "¿Quitar tu foto?",
    "people.edit.avatar.confirm.body":
      "Los demás verán tus iniciales. Siempre puedes elegir una foto nueva.",
    "people.edit.avatar.confirm.yes": "Sí, quitar",
    "people.problem.name.empty": "Escribe un nombre.",
    "people.problem.name.long": "Un nombre tiene como máximo 60 caracteres.",
    "people.problem.name.reserved": "Ese nombre no está disponible.",
    "people.problem.handle.length": "Elige de 3 a 30 caracteres.",
    "people.problem.handle.characters":
      "Usa solo letras minúsculas, cifras, punto, guion y guion bajo.",
    "people.problem.handle.edges": "Empieza y termina con una letra o una cifra.",
    "people.problem.handle.reserved": "Ese nombre de usuario no está disponible.",
    "people.problem.handle.taken": "Ese nombre de usuario ya está en uso.",
    "people.problem.handle.cooldown": "Puedes cambiar tu nombre de usuario una vez cada 30 días.",
    "people.group.role.makeOwner": "Hacer propietario",
    "people.group.role.makeAdmin": "Hacer administrador",
    "people.group.role.makeMember": "Hacer miembro",
    "people.group.stepDown": "Dejar de ser propietario",
    "people.group.stepDown.only":
      "Eres el único propietario. Primero haz propietario a otra persona; después podrás dejarlo.",
    "people.group.confirm.stepDown.title": "¿Dejar de ser propietario?",
    "people.group.confirm.stepDown.body":
      "Sigues siendo administrador del grupo. Otro propietario seguirá dirigiéndolo.",
    "people.group.confirm.stepDown.yes": "Sí, dejarlo",
    "people.group.confirm.makeOwner.title": "¿Hacer propietario a {name}?",
    "people.group.confirm.makeOwner.body":
      "Los propietarios pueden cambiar roles, quitar personas y eliminar el grupo.",
    "people.group.confirm.makeOwner.yes": "Sí, hacer propietario",
    "people.group.confirm.demoteOwner.title": "¿Quitar a {name} como propietario?",
    "people.group.confirm.demoteOwner.body":
      "{name} conserva un rol inferior en el grupo y ya no puede gestionarlo todo.",
    "people.group.confirm.demoteOwner.yes": "Sí, bajar el rol",
    "people.group.confirm.remove.title": "¿Quitar a {name} del grupo?",
    "people.group.confirm.remove.body": "{name} puede volver a unirse con una invitación.",
    "people.group.confirm.remove.yes": "Sí, quitar",
    "people.group.confirm.ban.title": "¿Vetar a {name}?",
    "people.group.confirm.ban.body":
      "{name} sale del grupo y no puede volver por enlace, código ni solicitud hasta que levantes el veto.",
    "people.group.confirm.ban.yes": "Sí, vetar",
    "people.group.confirm.leave.title": "¿Salir del grupo?",
    "people.group.confirm.leave.body":
      "Dejarás de ver el grupo y sus catas. Con una nueva invitación puedes volver a entrar.",
    "people.group.confirm.leave.yes": "Sí, salir",
    "people.group.confirm.delete.title": "¿Eliminar {name}?",
    "people.group.confirm.delete.body":
      "El grupo desaparece para todos los miembros. No se puede deshacer.",
    "people.group.confirm.delete.yes": "Sí, eliminar el grupo",
    "people.group.ban": "Vetar",
    "people.group.bans.title": "Vetados",
    "people.group.bans.unban": "Levantar el veto",
    "people.group.bans.unban.aria": "Levantar el veto a {name}",
    "people.group.report": "Denunciar el grupo",
    "people.group.error.lastOwner":
      "Un grupo siempre tiene un propietario. Primero haz propietario a otra persona.",
  },
  it: {
    "people.sheet.label": "Profilo di {name}",
    "people.state.friends": "Amici",
    "people.state.request_sent": "Richiesta inviata",
    "people.state.request_received": "Ti ha inviato una richiesta",
    "people.state.blocked": "Bloccato",
    "people.mutual.friends": "Amici in comune",
    "people.mutual.more": "e altri {n}",
    "people.mutual.groups": "Gruppi in comune",
    "people.mutual.none": "Ancora nessun amico o gruppo in comune.",
    "people.sheet.unavailable": "Questa persona non può essere mostrata.",
    "people.action.add": "Aggiungi amico",
    "people.action.cancel": "Annulla la richiesta",
    "people.action.accept": "Accetta",
    "people.action.decline": "Rifiuta",
    "people.action.unfriend": "Rimuovi dagli amici",
    "people.action.block": "Blocca",
    "people.action.unblock": "Sblocca",
    "people.action.report": "Segnala",
    "people.confirm.no": "Annulla",
    "people.confirm.unfriend.title": "Rimuovere {name} dagli amici?",
    "people.confirm.unfriend.body":
      "Non vedrete più l'attività l'uno dell'altro. Con una nuova richiesta potete tornare amici.",
    "people.confirm.unfriend.yes": "Sì, rimuovi",
    "people.confirm.block.title": "Bloccare {name}?",
    "people.confirm.block.body":
      "Non vi vedrete più in ricerca, inviti e degustazioni. {name} non ne viene informato e la vostra amicizia finisce.",
    "people.confirm.block.yes": "Sì, blocca",
    "people.report.title": "Segnala {name}",
    "people.report.aspect": "Cosa vuoi segnalare?",
    "people.report.aspect.whole.user": "Questa persona",
    "people.report.aspect.whole.group": "Questo gruppo",
    "people.report.aspect.name": "Il nome",
    "people.report.aspect.avatar": "L'immagine",
    "people.report.reason": "Motivo",
    "people.report.reason.spam": "Spam o inviti indesiderati",
    "people.report.reason.harassment": "Molestie o bullismo",
    "people.report.reason.impersonation": "Si finge un'altra persona",
    "people.report.reason.inappropriate": "Contenuto inappropriato",
    "people.report.reason.other": "Altro",
    "people.report.note": "Dettagli (facoltativo)",
    "people.report.note.hint": "Massimo 500 caratteri. Solo l'operatore di proef lo legge.",
    "people.report.submit": "Invia segnalazione",
    "people.report.limit": "Oggi hai già segnalato molto. Riprova domani.",
    "people.report.sent.title": "Grazie per la segnalazione",
    "people.report.sent.body":
      "La esamineremo. L'altra persona non viene a sapere che hai segnalato.",
    "people.report.sent.block": "Blocca anche {name}",
    "people.report.sent.done": "Fatto",
    "people.blocked.title": "Persone bloccate",
    "people.blocked.hint":
      "Le persone bloccate non ti vedono in ricerca, inviti e degustazioni e non ne vengono informate.",
    "people.blocked.empty": "Non hai bloccato nessuno.",
    "people.blocked.unblock": "Sblocca",
    "people.blocked.unblock.aria": "Sblocca {name}",
    "people.edit.open": "Modifica profilo",
    "people.edit.title": "Modifica il tuo profilo",
    "people.edit.name": "Nome",
    "people.edit.handle": "Nome utente",
    "people.edit.handle.hint":
      "Da 3 a 30 caratteri: lettere minuscole, cifre, punto, trattino o trattino basso. Puoi cambiarlo una volta ogni 30 giorni.",
    "people.edit.save": "Salva",
    "people.edit.saved": "Salvato.",
    "people.edit.avatar.file": "Nuova foto",
    "people.edit.avatar.remove": "Rimuovi la foto",
    "people.edit.avatar.tooBig": "La foto è troppo grande. Scegline una più piccola.",
    "people.edit.avatar.badType": "Scegli una foto jpg, png o webp.",
    "people.edit.avatar.confirm.title": "Rimuovere la tua foto?",
    "people.edit.avatar.confirm.body":
      "Gli altri vedranno le tue iniziali. Puoi sempre scegliere una nuova foto.",
    "people.edit.avatar.confirm.yes": "Sì, rimuovi",
    "people.problem.name.empty": "Inserisci un nome.",
    "people.problem.name.long": "Un nome ha al massimo 60 caratteri.",
    "people.problem.name.reserved": "Questo nome non è disponibile.",
    "people.problem.handle.length": "Scegli da 3 a 30 caratteri.",
    "people.problem.handle.characters":
      "Usa solo lettere minuscole, cifre, punto, trattino e trattino basso.",
    "people.problem.handle.edges": "Inizia e finisci con una lettera o una cifra.",
    "people.problem.handle.reserved": "Questo nome utente non è disponibile.",
    "people.problem.handle.taken": "Questo nome utente è già in uso.",
    "people.problem.handle.cooldown": "Puoi cambiare il nome utente una volta ogni 30 giorni.",
    "people.group.role.makeOwner": "Rendi proprietario",
    "people.group.role.makeAdmin": "Rendi amministratore",
    "people.group.role.makeMember": "Rendi membro",
    "people.group.stepDown": "Lascia il ruolo di proprietario",
    "people.group.stepDown.only":
      "Sei l'unico proprietario. Rendi prima proprietaria un'altra persona, poi potrai lasciare il ruolo.",
    "people.group.confirm.stepDown.title": "Non essere più proprietario?",
    "people.group.confirm.stepDown.body":
      "Resti amministratore del gruppo. Un altro proprietario continua a gestirlo.",
    "people.group.confirm.stepDown.yes": "Sì, lascia il ruolo",
    "people.group.confirm.makeOwner.title": "Rendere {name} proprietario?",
    "people.group.confirm.makeOwner.body":
      "I proprietari possono cambiare i ruoli, rimuovere persone ed eliminare il gruppo.",
    "people.group.confirm.makeOwner.yes": "Sì, rendi proprietario",
    "people.group.confirm.demoteOwner.title": "Togliere a {name} il ruolo di proprietario?",
    "people.group.confirm.demoteOwner.body":
      "{name} mantiene un ruolo inferiore nel gruppo e non può più gestire tutto.",
    "people.group.confirm.demoteOwner.yes": "Sì, abbassa il ruolo",
    "people.group.confirm.remove.title": "Rimuovere {name} dal gruppo?",
    "people.group.confirm.remove.body": "{name} può rientrare con un invito.",
    "people.group.confirm.remove.yes": "Sì, rimuovi",
    "people.group.confirm.ban.title": "Escludere {name}?",
    "people.group.confirm.ban.body":
      "{name} esce dal gruppo e non può tornare tramite link, codice o richiesta finché non revochi l'esclusione.",
    "people.group.confirm.ban.yes": "Sì, escludi",
    "people.group.confirm.leave.title": "Lasciare il gruppo?",
    "people.group.confirm.leave.body":
      "Non vedrai più il gruppo né le sue degustazioni. Con un nuovo invito puoi rientrare.",
    "people.group.confirm.leave.yes": "Sì, lascia",
    "people.group.confirm.delete.title": "Eliminare {name}?",
    "people.group.confirm.delete.body":
      "Il gruppo scompare per tutti i membri. L'azione non si può annullare.",
    "people.group.confirm.delete.yes": "Sì, elimina il gruppo",
    "people.group.ban": "Escludi",
    "people.group.bans.title": "Esclusi",
    "people.group.bans.unban": "Revoca l'esclusione",
    "people.group.bans.unban.aria": "Revoca l'esclusione di {name}",
    "people.group.report": "Segnala il gruppo",
    "people.group.error.lastOwner":
      "Un gruppo ha sempre un proprietario. Rendi prima proprietaria un'altra persona.",
  },
  pt: {
    "people.sheet.label": "Perfil de {name}",
    "people.state.friends": "Amigos",
    "people.state.request_sent": "Pedido enviado",
    "people.state.request_received": "Enviou-te um pedido",
    "people.state.blocked": "Bloqueado",
    "people.mutual.friends": "Amigos em comum",
    "people.mutual.more": "e mais {n}",
    "people.mutual.groups": "Grupos em comum",
    "people.mutual.none": "Ainda sem amigos ou grupos em comum.",
    "people.sheet.unavailable": "Não é possível mostrar esta pessoa.",
    "people.action.add": "Adicionar amigo",
    "people.action.cancel": "Cancelar pedido",
    "people.action.accept": "Aceitar",
    "people.action.decline": "Recusar",
    "people.action.unfriend": "Desfazer amizade",
    "people.action.block": "Bloquear",
    "people.action.unblock": "Desbloquear",
    "people.action.report": "Denunciar",
    "people.confirm.no": "Cancelar",
    "people.confirm.unfriend.title": "Desfazer a amizade com {name}?",
    "people.confirm.unfriend.body":
      "Deixam de ver a atividade um do outro. Com um novo pedido podem voltar a ser amigos.",
    "people.confirm.unfriend.yes": "Sim, desfazer",
    "people.confirm.block.title": "Bloquear {name}?",
    "people.confirm.block.body":
      "Deixam de se ver na pesquisa, nos convites e nas provas. {name} não é avisado e a vossa amizade termina.",
    "people.confirm.block.yes": "Sim, bloquear",
    "people.report.title": "Denunciar {name}",
    "people.report.aspect": "O que queres denunciar?",
    "people.report.aspect.whole.user": "Esta pessoa",
    "people.report.aspect.whole.group": "Este grupo",
    "people.report.aspect.name": "O nome",
    "people.report.aspect.avatar": "A imagem",
    "people.report.reason": "Motivo",
    "people.report.reason.spam": "Spam ou convites indesejados",
    "people.report.reason.harassment": "Assédio ou intimidação",
    "people.report.reason.impersonation": "Faz-se passar por outra pessoa",
    "people.report.reason.inappropriate": "Conteúdo inadequado",
    "people.report.reason.other": "Outra coisa",
    "people.report.note": "Detalhes (opcional)",
    "people.report.note.hint": "Até 500 caracteres. Só o operador do proef lê isto.",
    "people.report.submit": "Enviar denúncia",
    "people.report.limit": "Hoje já denunciaste muito. Tenta de novo amanhã.",
    "people.report.sent.title": "Obrigado pela denúncia",
    "people.report.sent.body": "Vamos analisá-la. A outra pessoa não sabe que denunciaste.",
    "people.report.sent.block": "Bloquear também {name}",
    "people.report.sent.done": "Concluído",
    "people.blocked.title": "Pessoas bloqueadas",
    "people.blocked.hint":
      "As pessoas bloqueadas não te veem na pesquisa, nos convites e nas provas, e não são avisadas.",
    "people.blocked.empty": "Não bloqueaste ninguém.",
    "people.blocked.unblock": "Desbloquear",
    "people.blocked.unblock.aria": "Desbloquear {name}",
    "people.edit.open": "Editar perfil",
    "people.edit.title": "Editar o teu perfil",
    "people.edit.name": "Nome",
    "people.edit.handle": "Nome de utilizador",
    "people.edit.handle.hint":
      "De 3 a 30 caracteres: letras minúsculas, algarismos, ponto, hífen ou sublinhado. Podes alterá-lo uma vez a cada 30 dias.",
    "people.edit.save": "Guardar",
    "people.edit.saved": "Guardado.",
    "people.edit.avatar.file": "Foto nova",
    "people.edit.avatar.remove": "Remover foto",
    "people.edit.avatar.tooBig": "Essa foto é demasiado grande. Escolhe uma mais pequena.",
    "people.edit.avatar.badType": "Escolhe uma foto jpg, png ou webp.",
    "people.edit.avatar.confirm.title": "Remover a tua foto?",
    "people.edit.avatar.confirm.body":
      "Os outros passam a ver as tuas iniciais. Podes sempre escolher uma foto nova.",
    "people.edit.avatar.confirm.yes": "Sim, remover",
    "people.problem.name.empty": "Escreve um nome.",
    "people.problem.name.long": "Um nome tem no máximo 60 caracteres.",
    "people.problem.name.reserved": "Esse nome não está disponível.",
    "people.problem.handle.length": "Escolhe de 3 a 30 caracteres.",
    "people.problem.handle.characters":
      "Usa só letras minúsculas, algarismos, ponto, hífen e sublinhado.",
    "people.problem.handle.edges": "Começa e termina com uma letra ou um algarismo.",
    "people.problem.handle.reserved": "Esse nome de utilizador não está disponível.",
    "people.problem.handle.taken": "Esse nome de utilizador já está em uso.",
    "people.problem.handle.cooldown":
      "Podes alterar o teu nome de utilizador uma vez a cada 30 dias.",
    "people.group.role.makeOwner": "Tornar proprietário",
    "people.group.role.makeAdmin": "Tornar administrador",
    "people.group.role.makeMember": "Tornar membro",
    "people.group.stepDown": "Deixar de ser proprietário",
    "people.group.stepDown.only":
      "És o único proprietário. Torna primeiro outra pessoa proprietária; depois podes deixar o papel.",
    "people.group.confirm.stepDown.title": "Deixar de ser proprietário?",
    "people.group.confirm.stepDown.body":
      "Continuas administrador do grupo. Outro proprietário continua a geri-lo.",
    "people.group.confirm.stepDown.yes": "Sim, deixar o papel",
    "people.group.confirm.makeOwner.title": "Tornar {name} proprietário?",
    "people.group.confirm.makeOwner.body":
      "Os proprietários podem mudar papéis, remover pessoas e eliminar o grupo.",
    "people.group.confirm.makeOwner.yes": "Sim, tornar proprietário",
    "people.group.confirm.demoteOwner.title": "Retirar a {name} o papel de proprietário?",
    "people.group.confirm.demoteOwner.body":
      "{name} fica com um papel inferior no grupo e já não pode gerir tudo.",
    "people.group.confirm.demoteOwner.yes": "Sim, baixar o papel",
    "people.group.confirm.remove.title": "Remover {name} do grupo?",
    "people.group.confirm.remove.body": "{name} pode voltar a entrar com um convite.",
    "people.group.confirm.remove.yes": "Sim, remover",
    "people.group.confirm.ban.title": "Banir {name}?",
    "people.group.confirm.ban.body":
      "{name} sai do grupo e não pode voltar por ligação, código ou pedido até levantares o banimento.",
    "people.group.confirm.ban.yes": "Sim, banir",
    "people.group.confirm.leave.title": "Sair do grupo?",
    "people.group.confirm.leave.body":
      "Deixas de ver o grupo e as suas provas. Com um novo convite podes voltar a entrar.",
    "people.group.confirm.leave.yes": "Sim, sair",
    "people.group.confirm.delete.title": "Eliminar {name}?",
    "people.group.confirm.delete.body":
      "O grupo desaparece para todos os membros. Não é possível desfazer.",
    "people.group.confirm.delete.yes": "Sim, eliminar o grupo",
    "people.group.ban": "Banir",
    "people.group.bans.title": "Banidos",
    "people.group.bans.unban": "Levantar o banimento",
    "people.group.bans.unban.aria": "Levantar o banimento de {name}",
    "people.group.report": "Denunciar o grupo",
    "people.group.error.lastOwner":
      "Um grupo tem sempre um proprietário. Torna primeiro outra pessoa proprietária.",
  },
} as const;
